// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__ESignaturePage__qndIframeHeight{height:60vh!important}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/gw-capability-quoteandbind-common-react/pages/ESignature/ESignaturePage.module.scss"],"names":[],"mappings":"AAAA,sCACE,qBAAA","sourcesContent":[".qndIframeHeight{\n  height: 60vh !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"qndIframeHeight": "app__ESignaturePage__qndIframeHeight"
};
export default ___CSS_LOADER_EXPORT___;
